<template>
  <div class="fa-call" v-if="showModal && authenticate">
    <div class="container">
      <svg
        @click.prevent="closeModal"
        class="close"
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.9584 24.0417C1.17735 23.2606 1.17735 21.9943 1.9584 21.2132L21.7574 1.41424C22.5384 0.633189 23.8048 0.63319 24.5858 1.41424C25.3669 2.19529 25.3669 3.46162 24.5858 4.24267L4.78683 24.0417C4.00578 24.8227 2.73945 24.8227 1.9584 24.0417Z"
          fill="#194589"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.95835 1.68619C2.73939 0.905138 4.00572 0.905138 4.78677 1.68619L24.5858 21.4852C25.3668 22.2662 25.3668 23.5326 24.5858 24.3136C23.8047 25.0947 22.5384 25.0947 21.7573 24.3136L1.95835 4.51461C1.1773 3.73356 1.1773 2.46723 1.95835 1.68619Z"
          fill="#194589"
        />
      </svg>

      <p class="header">{{ $t("services.titlePopup") }}</p>

      <!-- <div class="fa-buttons"> -->
      <div class="fa-buttons fa-scrollable">
        <!-- <div
          class="arr arr-left"
          :class="{ disabled: step === 0 }"
          @click.prevent="prevStep"
        >
          <svg
            width="55"
            height="55"
            viewBox="0 0 55 55"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="27.5"
              cy="27.5"
              r="27.5"
              fill="black"
              fill-opacity="0.4"
            />
            <path
              d="M17.9375 26.9375L29.9375 15C30.5 14.375 31.4375 14.375 32.0625 15C32.625 15.5625 32.625 16.5 32.0625 17.0625L21.0625 28L32 39C32.625 39.5625 32.625 40.5 32 41.0625C31.4375 41.6875 30.5 41.6875 29.9375 41.0625L17.9375 29.0625C17.3125 28.5 17.3125 27.5625 17.9375 26.9375Z"
              fill="white"
            />
          </svg> -->
        <!-- </div> -->
        <div class="buttons-container" @scroll="scrollSlider">
          <a
            class="button"
            href=""
            v-for="(item, index) in servicesToShow"
            :key="index"
            @click.prevent="setOrderAction(item)"
            :class="{
              active: orders.find((order) =>
                order.items.find((it) => it.id === item.id)
              ),
            }"
          >
            <span class="img">
              <img
                class="icon"
                width="58"
                height="48"
				:src="theme==='light'?replaceCoverImage(item.imagePopup):replaceCoverImage(item.imagePopupDark)"
                alt=""
              />
            </span>
            <strong>{{ item.titlePopup }}</strong>
            <svg
              class="clock"
              width="26"
              height="24"
              viewBox="0 0 26 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13 0C17.2656 0 21.2031 2.29688 23.3594 6C25.5156 9.75 25.5156 14.2969 23.3594 18C21.2031 21.75 17.2656 24 13 24C8.6875 24 4.75 21.75 2.59375 18C0.4375 14.2969 0.4375 9.75 2.59375 6C4.75 2.29688 8.6875 0 13 0ZM11.875 5.625V12C11.875 12.375 12.0625 12.75 12.3438 12.9375L16.8438 15.9375C17.3594 16.3125 18.0625 16.1719 18.4375 15.6562C18.7656 15.1406 18.625 14.4375 18.1094 14.0625L14.125 11.4375V5.625C14.125 5.01562 13.6094 4.5 13 4.5C12.3438 4.5 11.875 5.01562 11.875 5.625Z"
                fill="#F37920"
              />
            </svg>
            <em></em>
            <i
              v-if="
                orders.find((order) =>
                  order.items.find((it) => it.id === item.id)
                )
              "
              @click.prevent="cancelOrder({ id: item.id })"
            >
              {{ $t("services.cancelCall") }}
            </i>
            <i v-else>{{ $t("services.makeCall") }}</i>
            <svg
              @click.prevent="cancelOrder({ id: item.id })"
              class="cancel"
              width="52"
              height="48"
              viewBox="0 0 52 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M26 4.5C18.9688 4.5 12.5938 8.25 9.03125 14.25C5.5625 20.3438 5.5625 27.75 9.03125 33.75C12.5938 39.8438 18.9688 43.5 26 43.5C32.9375 43.5 39.3125 39.8438 42.875 33.75C46.3438 27.75 46.3438 20.3438 42.875 14.25C39.3125 8.25 32.9375 4.5 26 4.5ZM26 48C17.375 48 9.5 43.5 5.1875 36C0.875 28.5938 0.875 19.5 5.1875 12C9.5 4.59375 17.375 0 26 0C34.5312 0 42.4062 4.59375 46.7188 12C51.0312 19.5 51.0312 28.5938 46.7188 36C42.4062 43.5 34.5312 48 26 48ZM18.4062 16.4062C19.25 15.5625 20.6562 15.5625 21.5 16.4062L25.9062 20.8125L30.3125 16.4062C31.25 15.5625 32.6562 15.5625 33.5 16.4062C34.4375 17.3438 34.4375 18.75 33.5 19.5938L29.0938 24L33.5 28.4062C34.4375 29.3438 34.4375 30.75 33.5 31.5938C32.6562 32.5312 31.25 32.5312 30.3125 31.5938L25.9062 27.1875L21.5 31.5938C20.6562 32.5312 19.25 32.5312 18.4062 31.5938C17.4688 30.75 17.4688 29.3438 18.4062 28.4062L22.8125 24L18.4062 19.5938C17.4688 18.75 17.4688 17.3438 18.4062 16.4062Z"
                fill="#194589"
              />
            </svg>
          </a>
        </div>
        <!-- <div
          class="arr arr-right"
          :class="{ disabled: (carouselPositions.length - 1) === step }"
          @click.prevent="nextStep"
        >
          <svg
            width="55"
            height="55"
            viewBox="0 0 55 55"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="27.5"
              cy="27.5"
              r="27.5"
              fill="black"
              fill-opacity="0.4"
            />
            <path
              d="M36.0625 26.9375C36.625 27.5625 36.625 28.5 36.0625 29.0625L24.0625 41.0625C23.4375 41.6875 22.5 41.6875 21.9375 41.0625C21.3125 40.5 21.3125 39.5625 21.9375 39L32.875 28.0625L21.9375 17.0625C21.3125 16.5 21.3125 15.5625 21.9375 15C22.5 14.375 23.4375 14.375 24 15L36.0625 26.9375Z"
              fill="white"
            />
          </svg>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import cover from "@/mixins/cover";
import order from "@/mixins/order";

export default {
  name: "OrderHeader",
  mixins: [cover, order],
  data: () => {
    return {
      step: 0,
      carouselPositions: [],
    };
  },
  watch: {
    layoutLoading: {
      immediate: true,
      handler() {
        if (this.layoutLoading === "empty") {
          this.actionLayout();
        }
      },
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      //   this.$nextTick(() => {

      document.querySelectorAll(".buttons-container .button").forEach(
        function (div, index) {
          this.carouselPositions.push([
            index * div.offsetWidth,
            (index + 1) * div.offsetWidth, // add to array the positions information
          ]);
        }.bind(this)
      );
      //   });
    },
    prevStep() {
      if (this.step === 0) {
		return
    //     this.step = this.carouselPositions.length - 1;
      } else {
        this.step--;
      }
      let slider = document.querySelector(".buttons-container");
      if (slider) {
        slider.scrollTo({
          left: this.carouselPositions[this.step][0],
          behavior: "smooth",
        });
      }
	  console.log(this.step)
    },
    nextStep() {
        if (this.carouselPositions.length - 1 === this.step) {
			return
        //   this.step = 0;
        } else {
			this.step++;
        }
        let slider = document.querySelector(".buttons-container");
        if (slider) {
          slider.scrollTo({
            left: this.carouselPositions[this.step][0],
            behavior: "smooth",
          });
        }
    
    },
    scrollSlider() {
      document
        .querySelectorAll(".buttons-container .button")
        .forEach((div, index) => {
          let rect = div.getBoundingClientRect();
          if (rect.left >= 0 && rect.left <= 180) {
            this.step = index;
          }
        });
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}
</style>
